import React, { useEffect, useState } from 'react';

import FloatValidationLabel from './FloatValidationLabel';
import PropTypes from 'prop-types';
import postData from '../../../utilities/postData';
import usePrevious from '../../../utilities/usePrevious';

const MultiSelect = ({
    filter,
    lookupType,
    placeholder,
    name,
    onChange,
    validationError,
    value,
    ...props
}) => {
    const [data, setData] = useState({ items: [] });
    const previousFilter = usePrevious(filter);

    useEffect(() => {
        //verify something actually changed in the filter before making a new network call
        if (filter === undefined || (JSON.stringify(previousFilter) !== JSON.stringify(filter))) {
            //when sending options as children, we want to set lookupType to undefined
            if (lookupType !== undefined) {
                const postFilter = {
                    franchiseId: window.biztrax.franchiseId,
                    lookupType: lookupType,
                    selectedIds: value,
                    ...filter
                };
                postData('/api/lookups/selectOptions', postFilter, setData);
            };
        }
    }, [filter]);

    const isChecked = (id) => Array.isArray(value) ? value.includes(id) : false;

    const updateValue = (id) => {
        let currentValue = [...value];
        if (currentValue.includes(id)) {
            currentValue = currentValue.filter((item) => item !== id);
        } else {
            currentValue.push(id);
        }

        onChange({ target: { name: name, value: currentValue } });
    }

    const options = (data.items || []).map((item, index) => (
        <div key={item.id} className="d-flex" {...props}>
            <label className="custom-control custom-checkbox d-inline-flex">
                <input type="checkbox" className="custom-control-input" name={item.name}
                    checked={isChecked(item.id)}
                    onChange={() => updateValue(item.id)}
                />
                <span className="custom-control-label">&nbsp;</span>
            </label>
            <label style={{ marginLeft: '-5px' }}>{item.name}</label>
        </div>
    ));

    return (
        <div>
            <FloatValidationLabel validationError={validationError} />
            <div style={{ border: '1px solid #ced4da', borderRadius: '3px', padding: '5px', height: '125px', overflowY: 'auto' }} >
                {options}
            </div>
        </div>
    );
}

MultiSelect.defaultProps = {
    value: []
}

MultiSelect.propTypes = {
    lookupType: PropTypes.string,
    validationError: PropTypes.string,
    value: PropTypes.array
};

export default MultiSelect;